import React, { useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import { SvgIcon } from '@mui/material';
import * as styles from '../../offices/cards/cards.styles';
import type FacilityType from '../models/facility-type';
import getIconFromFacilityTypeEnum from '../utils/facility-type-enum-to-icon-mapper';
import Column from '../../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly initialFacilityType: FacilityType;
  readonly isChecked: boolean;
  readonly onClick: (value: FacilityType) => void;
}

const FacilityTypeCard = ({ initialFacilityType, isChecked, onClick }: Props): React.JSX.Element => {
  const [facilityType] = useState<FacilityType>({
    ...initialFacilityType,
  });

  return (
    <div className={style(styles.facilityTypeCard(true))} key={facilityType.facilityType}>
      <Row
        crossAxisAlignment={CrossAxisAlignment.Center}
        className={style(styles.emailBody)}
        onClick={(): void => {
          onClick(facilityType);
        }}
      >
        <SvgIcon>{getIconFromFacilityTypeEnum(facilityType.facilityType)}</SvgIcon>
        <Column className={style(styles.facilityTypeBodyText)}>
          <span className={style(styles.cardBody(false, true))}>{facilityType.translatedType}</span>
        </Column>
        <CheckIcon className={style(styles.checkIcon(isChecked))} />
      </Row>
    </div>
  );
};

export default FacilityTypeCard;
